import React from "react";
import { NavBar } from "../../components";
import "./tentangGenesaret.scss";
import { GerejaImg_01, GerejaImg_02 } from "../../assets";

const TentangGenesaret = () => {
  return (
    <div className="tentang-genesaret-page">
      <NavBar />

      <div className="tg-container">
        {/* Judul */}
        <h2 className="tg-title">Sejarah Singkat Genesaret</h2>

        <div className="tg-content-wrapper">
          {/* CARD FOTO GEREJA */}
          <div className="tg-images-row">
            <div className="tg-image-card">
              <img src={GerejaImg_02} alt="Gereja Genesaret" />
            </div>

            <div className="tg-image-card">
              <img src={GerejaImg_01} alt="Gereja Genesaret" />
            </div>
          </div>

          {/* KONTEN PARAGRAF */}
          <div className="tg-main-text">
            <p>
              JEMAAT GMIM Genesaret Pateten, mulanya merupakan Jemaat GMIM
              Nazareth Pateten. Karena pertimbangan adanya pertumbuhan dan
              perkembangan Jemaat akibat pertambahan wilayah dan perkembangan
              jumlah jemaat, maka untuk efektivitas dan pemenuhan kebutuhan
              pelayanan, resminya tahun 2004 Jemaat Nazareth Pateten dimekarkan
              menjadi 2 Jemaat.
            </p>

            <p>
              Peresmian jemaat Genesaret Pateten ditetapkan pada tanggal 1
              Agustus 2004, Surat Keputusan Badan Pekerja Majelis Jemaat Sinode
              GMIM No. 365 tanggal 26 Juli 2004, menempatkan sebagai jemaat yang
              ke–803 Gereja Masehi Injili di Minahasa (GMIM) dan dimasukkan
              dalam lingkup pelayanan majelis wilayah Bitung Dua.
            </p>

            <p>
              Tanggal 1 Agustus kemudian ditetapkan sebagai patokan pelaksanaan
              HUT jemaat di tiap tahun sebagai pengingat perjalanan pelayanan
              jemaat GMIM Genesaret Pateten hingga saat ini.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TentangGenesaret;
